import { useEffect } from 'react';

export interface GuaziSeo {
  title: string;
  description?: string;
  keywords?: string;
  canonical?: string;
}

const GUAZI_SITE_ORIGIN = 'https://www.guaziyingshi.net';

function guaziSetMeta(attr: 'name' | 'property', key: string, content: string) {
  if (typeof document === 'undefined') return;
  const selector = `meta[${attr}="${key}"]`;
  let el = document.head.querySelector(selector) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

/**
 * 按页面写入 SEO 内容（SPA 路由切换时动态更新 title / description / keywords / canonical）。
 */
export function guaziApplySeo(seo: GuaziSeo) {
  if (typeof document === 'undefined') return;
  document.title = seo.title || '';
  guaziSetMeta('name', 'description', seo.description || '');
  guaziSetMeta('name', 'keywords', seo.keywords || '');
  guaziSetMeta('property', 'og:title', seo.title || '');
  guaziSetMeta('property', 'og:description', seo.description || '');

  const canonicalHref = seo.canonical || `${GUAZI_SITE_ORIGIN}/`;
  let link = document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', canonicalHref);
}

export function useGuaziSeo(seo: GuaziSeo) {
  useEffect(() => {
    guaziApplySeo(seo);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [seo.title, seo.description, seo.keywords, seo.canonical]);
}